import IntroScreenHeader from './IntroScreenHeader'

export default IntroScreenHeader
